import selectProductImagesForAngle from "./selectProductImagesForAngle";

export default function selectProductImages(state) {
  const { selectedImageAngle } = state.app;
  return selectProductImagesForAngle(selectedImageAngle)(state);
}
